import http from './http'
//查询详情
//新增/编辑
async function addAndEdit(key, that) {
    let res = await http['submit' + key](that.myForm, false)
    that.isLoading = false
    if (res) {
        that.cancel()
    }
}
//查询表格
export async function getData(key, that, pageNo = 1, timeout) {
    that.$set(that.query, 'page', pageNo) //有分页时设置当前页码
    let res = await http['get' + key + 'List'](that.query, false, {}, timeout)
    if (res) {
        that.list = res.data || []
        that.totalcount = res.totalcount
    }
}
//查询列表
export async function getSelect(key, that, param, callback, timeout) {
    let res = await http['get' + key + 'Select'](param, false, {}, timeout)
    if (res) {
        that[key + 'List'] = res.data || []
    }
}
//通用查询详情
export async function getDetail2(key, params, callback, timeout) {
    let res = await http['get' + key + 'Info'](params, false, {}, timeout)
    if (res) {
        let data = res.data
        if (data == null) {
            data = {}
        }
        callback && callback(data)
    }
}
export function saveData(apikey, that) {
    that.$refs.form.validate((valid) => {
        if (valid) {
            that.isLoading = true
            addAndEdit(apikey, that)
        }
    })
}
